(function () {
  var FORM_ID = '69ffb13c837b4a5c6c338514';
  var AUTO_OPEN_DELAY_MS = 2000;
  // sessionStorage suppresses auto-open after the popup has fired once per
  // browser session. Closing the tab and returning re-arms it. (Switch to
  // localStorage if you want once-per-browser-forever instead.)
  var STORAGE_KEY = 'launchModalAutoOpened';

  function openForm() {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', FORM_ID]);
  }

  // Click-to-open trigger (any element with data-launch-modal-open)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-launch-modal-open]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openForm();
  }, true);

  // Auto-open after the configured delay, once per session
  function scheduleAutoOpen() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
    } catch (_) { /* private mode / cookies disabled — fall through and still open */ }

    setTimeout(function () {
      openForm();
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
    }, AUTO_OPEN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAutoOpen);
  } else {
    scheduleAutoOpen();
  }
})();
